import React, { MouseEventHandler } from 'react';

import { Enhancer } from 'widgets-shared/core';
import { MessageBusType } from 'smartstream-widgets/types/sharedModule/core';

type Props = {
  messageBus: MessageBusType;
};

export function getElementFromNativeEvent(event: React.SyntheticEvent) {
  const { nativeEvent: { target = {} } = {} } = event;
  if (target instanceof HTMLElement) {
    const { dataset, tagName } = target;
    if (dataset && tagName) {
      const dataAttributes = ['htCategory', 'htAction', 'htLabel', 'htValue'];
      const hasValidAttributes = Object.keys(dataset).some((key) => dataAttributes.includes(key));
      return hasValidAttributes ? target : null;
    }
  }
  return null;
}

export const withHotspotTracking: Enhancer = (ComposedComponent: any) => (props: Props): React.ReactNode => {
  const { messageBus } = props;
  const hotspotHandler: MouseEventHandler<HTMLElement> = (event) => {
    const trackedSelectors = ['a', '[data-ht-category]', '[data-ht-action]', '[data-ht-label]', '[data-ht-value]'];
    const target = event.target as HTMLElement
    const trackedElement = target.closest ? target.closest<HTMLElement>(trackedSelectors.join()) : getElementFromNativeEvent(event);

    if (trackedElement === null) return;

    const { htCategory, htAction, htLabel, htValue } = trackedElement.dataset;
    const trackedElementTag = trackedElement.tagName.toLowerCase();
    const href = trackedElementTag === 'a' && trackedElement.getAttribute('href');

    const messageBody = {
      category: `hotspot:${htCategory || trackedElementTag}`,
      action: htAction || (href && `redirect to ${href}`) || 'click',
      label: htLabel,
      value: htValue,
    };

    messageBus.dispatchEvent('widget:click', messageBody);
  };

  return (
    <div className={'hotspotTrackingContainer'} onClick={hotspotHandler} style={{ height: '100%' }}>
      <ComposedComponent {...props} />
    </div>
  );
};
